import { AccountSetMeReducer } from './types';

export const accountSetMeReducer: AccountSetMeReducer = (state, action) => {
  const { payload } = action;

  return {
    ...state,
    me: {
      ...state.me,
      ...payload,
    },
  };
};
